// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"f524f216","357":"dbbd01f7","517":"287f9a3a","561":"5edf914b"}[chunkId] + ".chunk.js";
};